import React from 'react';
import PageBanner from "@/components/pageBanner";

const TrainingTechnicalAnalysis = () => {
    return (
        <>
            <PageBanner title="Technical Analysis" slug="training-technical-analysis"/>
            <section className="generic-container py-14">

                <p>
                    Technical analysis is based on the premise that all market participants' actions influence price
                    changes, which can be predicted through chart patterns, trend lines, and various technical
                    indicators. It provides a structured market outlook by analyzing current and historical price
                    charts.
                </p>

                <p className={`font-bold text-lt-blue mt-8 text-2xl`}>Three Core Principles of Technical Analysis:</p>
                <ol className="list-decimal ml-8 mt-2">
                    <li>Market Prices Reflect All Available Information</li>
                    <li>Price Movements Follow Trends</li>
                    <li>History Tends to Repeat Itself</li>
                </ol>
                <p className={`mt-4`}>
                    Several key categories of technical analysis tools enable traders to identify optimal trade
                    execution points across different timeframes:
                </p>
                <ul className="list-disc ml-8 mt-2">
                    <li>Trend Lines and Support & Resistance Levels</li>
                    <li>Chart Patterns</li>
                    <li>Candlestick Formations</li>
                    <li>Technical Indicators</li>
                </ul>
                <p className={`mt-4`}>
                    By leveraging these tools, traders can improve their decision-making process and enhance their
                    trading strategies.
                </p>
                <p className={`mt-4`}>
                    This version maintains the integrity of the original content while enhancing clarity, professionalism, and readability. Let me know if you need any further refinements!
                </p>

            </section>
        </>
    );
};

export default TrainingTechnicalAnalysis;